import script from "./PositionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionDialog.vue?vue&type=script&setup=true&lang=js"

import "./PositionDialog.vue?vue&type=style&index=0&id=8843390e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8843390e"]])

export default __exports__